import styled from 'styled-components';

import { MenuItem as _MenuItem } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { wellzTheme } from '@wellz-theme/mui';

import { ChevronByParameter as _ChevronByParameter } from 'components/ChevronByParameter/ChevronByParameter';

import { styled as styledMui } from '@mui/material/styles';

export const MenuItem = styled(_MenuItem)`
  letter-spacing: 0.15px;
  color: ${wellzTheme.palette.text.primary};
`;

export const ChevronByParameter = styled(_ChevronByParameter)`
  fill: ${wellzTheme.palette.primary.main};
  margin-left: ${wellzTheme.spacing(1)};
`;

export const CustomWidthTooltip = styledMui(Tooltip)({
  [`& .${tooltipClasses.tooltip}`]: {
    width: '97px',
  },
});
